const $cybersecurity = $('.kaspersky-inc-cybersecurity');
const $value = $cybersecurity.find('.kaspersky-inc-cybersecurity__value');
const $progress = $cybersecurity.find('.kaspersky-inc-cybersecurity__progress');

const maxValue = 100;

function setValue(value) {
	if (typeof value !== 'number') {
		return;
	}

	if (value >= maxValue) {
		value = maxValue;
	} else if (value <= -maxValue) {
		value = -maxValue;
	}

	value = value > 0 ? `+${value}` : value;

	const isNegative = value < 0;
	const text = value ? `${Math.round(value)}%` : '';
	const progressWidth = `${Math.abs(value) / maxValue * 50}%`;

	$cybersecurity.toggleClass('is-negative', isNegative);
	$value.text(text);
	$progress.width(progressWidth);
}

export default {
	setValue,
};
